import React from 'react';
import { CssBaseline, Grid, Typography, withStyles } from '@material-ui/core';

import Topbar from '../components/Topbar';
import Footer from '../components/Footer';
import Container from '../components/Div/Container';
import MainTitle from '../components/Text/MainTitle';
// import Preparing from '../components/Preparing';

import { EVENT_IMG } from '../constatns';

const styles = (theme) => ({
  message: {
    padding: theme.spacing(2, 0, 5),
    color: '#555',
    textAlign: 'justifyContent',
    '& p': {
      marginBottom: '1.2em',
    },
  },
  divLine: {
    width: '100%',
    height: '1px',
    margin: theme.spacing(7, 0),
    backgroundColor: 'rgba(0,0,0,0.1)',
  },
});

class WelcomePage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      matches: window.matchMedia('(max-width:600px)').matches,
    };
  }

  componentDidMount() {}

  render() {
    const { classes, theme } = this.props;
    return (
      <div>
        <CssBaseline />
        <Topbar MIdx={0} SIdx={0} />
        <Container>
          <Grid container justifyContent={'center'}>
            <Grid item xs={8}>
              <MainTitle>Welcome Message</MainTitle>
            </Grid>
            {/* <Grid item xs={12}>
              <Preparing />
            </Grid> */}
            <Grid item xs={8}>
              <Typography variant="h6" color="primary" style={{ fontWeight: 'bold' }}>
                Dear Colleagues and KSPRS Members,
              </Typography>
            </Grid>
            <Grid item xs={8} className={classes.message}>
              <Typography>
                The Korean Society of Plastic and Reconstructive Surgeons would like to welcome our colleagues and friends from all over the
                world to PRS Korea 2022, held in Seoul, Korea, from November 11th to 13th. We are delighted and extremely excited to host
                this years event in person for the first time in three years. The pandemic has taken a toll on everyone, regardless of where
                we are located, and PRS KOREA 2022 will be a great break for everyone to meet in person.
              </Typography>
              <Typography>
                The goal of PRS KOREA 2022 is to improve our Knowledge through discussion, expand collaborative efforts through networking,
                and enjoy each other’s presence. This three-day conference will provide numerous presentations for both novice surgeons and
                experts. We will have worldwide experts delivering talks on a multitude of topics. The Songbaek lecture will be presented by
                Dr. David Song of Georgetown, a keynote by Dr. Phillip Blondeel of University Hospital Gent, Belgium, and an invited talk by
                Dr. Steve Cohen of University of California San Diego.
              </Typography>
              <Typography>
                We look forward to an intellectually stimulating and exciting conference, and we would like you to join us.
              </Typography>
              <Typography>Thank you in advance for your support, and we hope to meet everyone in person this November in Seoul.</Typography>
            </Grid>
            <Grid item container xs={8}>
              <Grid item>
                <img src={`${EVENT_IMG}/welcome/president_img.png`} alt="" />
              </Grid>
              <Grid item style={{ padding: theme.spacing(2, 0, 2, 2) }}>
                <img src={`${EVENT_IMG}/welcome/president_sign.png`} alt="" />
                <Typography style={{ fontWeight: 'bold', color: '#232323', marginTop: theme.spacing(1) }}>
                  Rong-Min Baek, M.D., Ph.D
                </Typography>
                <Typography style={{ color: '#555' }}>
                  Chairman of General Assembly of Korean Society of Plastic and Reconstructive Surgeons
                </Typography>
              </Grid>
            </Grid>
            <Grid item xs={8}>
              <p className={classes.divLine} />
            </Grid>
            <Grid item xs={8}>
              <Typography variant="h6" color="primary" style={{ fontWeight: 'bold' }}>
                Dear Friends throughout the World,
              </Typography>
            </Grid>
            <Grid item xs={8} className={classes.message}>
              <Typography>
                I am delighted to host the PRS KOREA, the annual meeting of the Korean Society of Plastic and Reconstructive Surgeons
                (KSPRS). Ever since a domestic KSPRS conference developed into an international meeting in 2011, PRS KOREA became one of the
                largest annual plastic surgery conferences in Asia. At the last PRS KOREA 2021, despite the COVID-19 pandemic crisis, a
                total of 1300 participants including 150 foreigners participated and engaged in passionate discussion.
              </Typography>
              <Typography>
                Leaving the past COVID-19 crisis behind, we are now in the process of regaining our daily lives. In this year, PRS KOREA
                2022 will be held as a face-to face meeting. As it is an onsite conference to be held after a long time, we will prepare the
                conference more carefully and put the safety of participants first to provide an academic venue that can be beneficial and
                helpful to everyone.
              </Typography>
              <Typography>
                We have again managed to invite over 50 international guest speakers including David Song, a chief of Surgery at MedStar
                Health/Gerogetown University, Phillip Blondeel, the 2022 President of the European Association of Plastic Surgeons (EURAPS),
                and Steve R. Cohen, a clinical professor of plastic surgery at University of California. Along with these exceptional guest
                speakers, many acclaimed Korean speakers will also discuss various subjects on aesthetic and reconstructive surgery, and the
                will give us an opportunity for meaningful and productive deliveration.
              </Typography>
              <Typography>
                We expect PRS KOREA 2022 to offer a place of exchange and harmony where we can share first-class scientific programs and
                present cutting-edge research and practices.
                <br /> It will allow us to take a step toward a better future.
              </Typography>
              <Typography>PRS KOREA 2022 meeting awaits you to be a part of the new beginning.</Typography>
              <Typography>Please, come and join us! Thank you.</Typography>
            </Grid>
            <Grid item container xs={8}>
              <Grid item>
                <img src={`${EVENT_IMG}/welcome/chairman_img.png`} alt="" />
              </Grid>
              <Grid item style={{ padding: theme.spacing(2, 0, 2, 2) }}>
                <img src={`${EVENT_IMG}/welcome/chairman_sign.png`} alt="" />
                <Typography style={{ fontWeight: 'bold', color: '#232323', marginTop: theme.spacing(1) }}>
                  Eul Sik Yoon, M.D., Ph.D
                </Typography>
                <Typography style={{ color: '#555' }}>President of Korean Society of Plastic and Reconstructive Surgeons</Typography>
              </Grid>
            </Grid>
            {/* ===== */}
            <Grid item xs={8}>
              <p className={classes.divLine} />
            </Grid>
            <Grid item xs={8}>
              <Typography variant="h6" color="primary" style={{ fontWeight: 'bold' }}>
                Dear Colleagues,
              </Typography>
            </Grid>
            <Grid item xs={8} className={classes.message}>
              <Typography>
                I hope that you are all doing well and have been wisely coping with difficulties due to the COVID-19 pandemic and
                unprecedently severe weather during the summer.
              </Typography>
              <Typography>The COVID-19 pandemic, which seemed unlikely to disappear, now appears to be winding down. </Typography>
              <Typography>
                This year’s summer marked by extremely hot and sultry weather has finally ended and the cool autumn season has now begun.
              </Typography>
              <Typography>
                I believe that each individual member has been earnestly engaged in meeting patients’ needs and his or her professional
                responsibilities despite the increasingly challenging medical environment.
              </Typography>
              <Typography>
                I would like to express my deep gratitude again for your active participation and support that crucially contributed to the
                successful hosting of the Research and Reconstruction Forum and the 2022 Spring Symposium of the KCPCA last spring.
              </Typography>
              <Typography>
                We are now preparing the fall meeting of the Korean Society of Plastic and Reconstructive Surgeons and the Korean Cleft
                Palate-Craniofacial Association. This year, we are making preparations to organize a face-to-face conference to provide an
                opportunity to exchange information and ideas with each other and build social relationships through face-to-face
                communication.
              </Typography>
              <Typography>
                The KCPCA has become a leading academic society in the world through the efforts of its members over the past several
                decades, and this growth of the KCPCA has also led to the elevation of the status of its members as medical professionals.
              </Typography>
              <Typography>
                However, there are still a number of tasks that we need to fulfill for the further development of the KCPCA.
              </Typography>
              <Typography>We ask for your special attention to and active participation in the upcoming fall meeting. </Typography>
              <Typography>I wish you all continued happiness and prosperity in your life both at home and at work. </Typography>
            </Grid>
            <Grid item container xs={8}>
              <Grid item>
                <img src={`${EVENT_IMG}/welcome/welcome_img_3.png`} alt="" style={{ borderRadius: '50%', border: '5px solid #d4debc' }} />
              </Grid>
              <Grid item style={{ padding: theme.spacing(2, 0, 2, 2) }}>
                {/* <img src={`${EVENT_IMG}/welcome/chairman_sign.png`} alt="" /> */}
                <Typography style={{ fontWeight: 'bold', color: '#232323', marginTop: theme.spacing(1), paddingTop: 60 }}>
                  Sung-Hoon Koh, M.D., Ph.D
                </Typography>
                <Typography style={{ color: '#555' }}>
                  {/* President of the Korean Cleft Palate-Craniofacial Association */}
                  {/* Chairman of General Assembly of the Korean Cleft Palate-Craniofacial Association */}
                  Chairman of General Assembly of Korean Cleft Palate-Craniofacial Association
                </Typography>
              </Grid>
            </Grid>

            {/* ===== */}
            <Grid item xs={8}>
              <p className={classes.divLine} />
            </Grid>
            <Grid item xs={8}>
              <Typography variant="h6" color="primary" style={{ fontWeight: 'bold' }}>
                Dear Members of the Korean Cleft Palate-Craniofacial Association,
              </Typography>
            </Grid>
            <Grid item xs={8} className={classes.message}>
              <Typography>
                {/* I am Choi, Jong-Woo, who has been appointed as the chairman of the board of the Korean Cleft Palate-Craniofacial Association */}
                I am Choi, Jong-Woo, who has been appointed as the President of the Korean Cleft Palate-Craniofacial Association (KCPCA). I
                am very grateful and honored to serve as the chairman and I am very pleased to meet you all.
              </Typography>
              <Typography>
                Craniofacial surgery is a subspecialty of plastic surgery where various clinical applications of emerging technologies
                presented and signified by the fourth industrial revolution are adopted earlier than in any other fields of medicine, and
                this area has been receiving wide attention again in recent years. I am confident that the convergence of clinical
                application and emerging technologies such as 3D computer simulation, 3D printing technology, augmented reality, virtual
                reality, and artificial intelligence will give us an opportunity for a great leap forward for the development of this
                medical field. The development potential in the clinical applications of these emerging information technologies has been
                confirmed at the 2022 Spring Symposium of the KCPCA.
              </Typography>
              <Typography>
                The field of craniofacial surgery has tried to empathically identify and deal with the problems of patients with congenital
                malformations as their longtime companion over a long period from birth to adulthood, and has helped patients suffering from
                congenital deformities by providing treatment for them with advanced medical technologies. Regarding recent surgical
                innovations in this field, PRS KOREA 2022 will provide an opportunity to reexamine and discuss cutting-edge technologies for
                surgical management for congenital malformations. In particular, the program of PRS KOREA 2022 will feature lectures by
                distinguished surgeons such as Dr. Emeka Nkenke, Dr. Steve Cohen, and Prof. Yuzo Komuro. Dr. Emeka Nkenke is the
                editor-in-chief of the Journal of Cranio-Maxillofacial Surgery (JCMFS) and a professor of Medical University of Vienna,
                Austria, and Dr. Steve Cohen and Prof. Yuzo Komuro are renowned surgeons in the field of craniofacial surgery. In addition,
                Korea’s eminent surgeons well-versed in the surgical management of congenital anomalies will also deliver lectures on
                congenital malformations, and Prof. Koh, Kyung-Suk, a renowned authority on cleft lip and palate surgery, will give a
                pre-retirement lecture
              </Typography>
              <Typography>
                Regarding the number of patients with congenital malformations, recent statistical data showed that there has been no
                decline in the prevalence of congenital malformations in contrast to the expectation of some healthcare professionals. If we
                aim to completely resolve the stigma of patients with congenital deformities, we should make continuous efforts for the
                further development of surgical technologies and techniques. Thus, in view of the potential for further development of
                surgical technology, a large number of plastic surgeons should pay more attention to and make greater effort for the
                technological innovations in this field of medicine.
              </Typography>
              <Typography>
                I hope that PRS Korea 2022 will provide you with an opportunity for the exchange of information and opinions on a broad
                range of issues including academic topics between Korean and foreign medical researchers.
              </Typography>
            </Grid>
            <Grid item container xs={8}>
              <Grid item>
                <img src={`${EVENT_IMG}/welcome/welcome_img_4.png`} alt="" style={{ borderRadius: '50%', border: '5px solid #d4debc' }} />
              </Grid>
              <Grid item style={{ padding: theme.spacing(2, 0, 2, 2) }}>
                {/* <img src={`${EVENT_IMG}/welcome/chairman_sign.png`} alt="" /> */}
                <Typography style={{ fontWeight: 'bold', color: '#232323', marginTop: theme.spacing(1), paddingTop: 60 }}>
                  Jong Woo Choi, M.D., Ph.D
                </Typography>
                <Typography style={{ color: '#555' }}>President of Korean Cleft Palate-Craniofacial Association</Typography>
              </Grid>
            </Grid>

            {/* ===== */}

            <Grid item xs={8}>
              <p className={classes.divLine} />
            </Grid>
            <Grid item xs={8}>
              <Typography variant="h6" color="primary" style={{ fontWeight: 'bold' }}>
                Greetings from the Seoul Rhinoplasty Forum (SRF) invitation,
              </Typography>
            </Grid>
            <Grid item xs={8} className={classes.message}>
              <Typography>
                The Seoul Rhinoplasty Forum 2022 will be held in Seoul on November 13, 2022, along with PRS Korea 2022. It will be an
                excellent opportunity to meet many overseas colleagues who have not been able to meet in person for a long time due to
                COVID-19.
              </Typography>
              <Typography>
                The theme of PRS Korea at this time is “humanity beyond technology”. Our technology has been advancing tremendously in all
                areas, but the unexpected Covid-19 pandemic put everything on hold for nearly three years. After being isolated and having
                time to reflect, we can develop through meetings, discussions, and agreement.
              </Typography>
              <Typography>
                The Seoul Rhinoplasty Forum has grown and developed academically in the field of rhinoplasty in Asia. Every year, we had
                active academic exchanges with great speakers from many countries. I hope this PRS Korea 2022 will be an opportunity to
                re-create the opportunity for academic exchanges that had been stopped by the Covid-19 outbreak. I hope that many of you
                will participate in the PRS Korea and Seoul Rhinoplasty Forum for the continuous development of the plastic surgery field.
              </Typography>
            </Grid>
            <Grid item container xs={8}>
              <Grid item>
                <img src={`${EVENT_IMG}/welcome/welcome_img_6.png`} alt="" style={{ borderRadius: '50%', border: '5px solid #d4debc' }} />
              </Grid>
              <Grid item style={{ padding: theme.spacing(2, 0, 2, 2) }}>
                {/* <img src={`${EVENT_IMG}/welcome/chairman_sign.png`} alt="" /> */}
                <Typography style={{ fontWeight: 'bold', color: '#232323', marginTop: theme.spacing(1), paddingTop: 60 }}>
                  JaeYong Jeong, M.D., Ph.D
                </Typography>
                <Typography style={{ color: '#555' }}>
                  {/* Chairman of Seoul Breast Meeting 2022 */}
                  {/* Chairman of General Assembly of Seoul Rhinoplasty Forum */}
                  President of Seoul Rhinoplasty Forum
                </Typography>
              </Grid>
            </Grid>

            {/* ===== */}

            <Grid item xs={8}>
              <p className={classes.divLine} />
            </Grid>
            <Grid item xs={8}>
              <Typography variant="h6" color="primary" style={{ fontWeight: 'bold' }}>
                Dear Members of the Korean Society of Plastic and Reconstructive Surgeons,
              </Typography>
            </Grid>
            <Grid item xs={8} className={classes.message}>
              <Typography>
                I am very pleased to hear that the 2022 fall meeting of the Korean Society of Plastic and Reconstructive Surgeons (KSPRS)
                will be held at the end of this autumn as an offline event in a face-to-face manner for the first time in three years.
              </Typography>
              <Typography>
                I happily expect the reactivation of the activities of the Society, now that we are able to perform the most important
                activities of plastic surgeons in a conventional manner as we did before the pandemic period.
              </Typography>
              <Typography>
                PRS, which is an important international academic meeting of Korean plastic surgeons, achieved rapid development over
                several years prior to the outbreak of the COVID-19, and it was expected to elevate the status and values of its members in
                the international scientific community and be established as one of the best international academic meetings of plastic
                surgeons. However, regrettably, the COVID-19 pandemic presented an obstacle to the continuous growth and development of PRS.
              </Typography>
              <Typography>
                Nevertheless, the selfless dedication and efforts of a number of members enabled the continued progress of PRS even during
                the past two years.
              </Typography>
              <Typography>
                I would like to express my deep gratitude to the chairman of the board, executive directors and officers of the KSPRS as
                well as presenters and session chairs that participated in PRS, who allowed the attendees of PRS to have excellent academic
                experiences by developing new online formats in a challenging environment.
              </Typography>
              <Typography>
                I think that appropriately converting PRS into an offline event would not have been possible without the painstaking efforts
                of many people preparing the conference. Thus, I would like to express my sincere appreciation to people who have dedicated
                a great deal of their time and effort to prepare for PRS KOREA 2022, and hope that PRS KOREA 2022 will become a successful
                academic event.
              </Typography>
              <Typography>
                We are pleased and honored about the fact that Seoul Breast Meeting is going to jointly participate in PRS KOREA 2022, which
                will be held offline this year. The Breast Surgery Study Group is making efforts to conduct research on the standard and
                safe practice of breast reconstruction and aesthetic breast surgery and investigate and introduce new surgical techniques
                and useful information
              </Typography>
              <Typography>
                The Breast Surgery Study Group aims at the internationalization of its activities including Seoul Breast Meeting through
                activities such as exchanges with overseas researchers and the introduction of Korean contents to international researchers.
                In this respect, this organization has the same direction of development as the KSPRS. Although Seoul Breast Meeting is
                currently held as a small-scale event, I believe that it would continue to develop and grow into a representative breast
                meeting in Asia in the near future.
              </Typography>
              <Typography>
                I hope that a number of surgeons will attend Seoul Breast Meeting that is scheduled to be held on Saturday and have an
                opportunity to share and obtain useful information and ideas.
              </Typography>
            </Grid>
            <Grid item container xs={8}>
              <Grid item>
                <img src={`${EVENT_IMG}/welcome/welcome_img_5.png`} alt="" style={{ borderRadius: '50%', border: '5px solid #d4debc' }} />
              </Grid>
              <Grid item style={{ padding: theme.spacing(2, 0, 2, 2) }}>
                {/* <img src={`${EVENT_IMG}/welcome/chairman_sign.png`} alt="" /> */}
                <Typography style={{ fontWeight: 'bold', color: '#232323', marginTop: theme.spacing(1), paddingTop: 60 }}>
                  Jin Sup Eom, M.D., Ph.D
                </Typography>
                <Typography style={{ color: '#555' }}>
                  {/* Chairman of Seoul Breast Meeting 2022 */}
                  {/* Chairman of General Assembly of Seoul Breast Meeting 2022 */}
                  President of Seoul Breast Meeting 2022
                </Typography>
              </Grid>
            </Grid>

            {/* ===== */}

            <Grid item xs={8}>
              <p className={classes.divLine} />
            </Grid>
            <Grid item xs={8}>
              <Typography variant="h6" color="primary" style={{ fontWeight: 'bold' }}>
                On behalf of the AFS board members,
              </Typography>
            </Grid>
            <Grid item xs={8} className={classes.message}>
              <Typography>
                It is an honor to hold The 5th Asian Forum for Fat Grafting and Stem Cells(AFS) with PRS KOREA 2022 in Seoul, Korea.
              </Typography>
              <Typography>
                AFS was founded to exchange opinions, give presentations and make friendships among plastic surgeons in ASIA interested in
                performing fat grafting and clinical application of adipose stem cells. Over the past two years, however, COVID-19 has
                constrained many AFS activities, including academic conferences.
              </Typography>
              <Typography>
                The global crisis caused by the pandemic has stabilized, and face-to-face AFS forums are now possible, allowing for more
                intimate and in-depth discussions. Even in difficult times, we have continued our ongoing research, efforts, and academic
                exchange. As a result, new topics and speakers have been prepared for the 5th AFS. We do not have a long history, but we
                have many enthusiastic members searching for advanced knowledge and new surgical techniques to enhance the quality of human
                life.
              </Typography>
              <Typography>
                In the future, AFS aims to be the cornerstone for plastic surgeons in Asia to become leaders in worldwide societies. That is
                why AFS aims to be held and tour annually in Asia.
              </Typography>
              <Typography>
                Thank you to the Faculty members who have participated every year. I am looking forward to meeting you again.
              </Typography>
              <Typography>Study must go on.</Typography>
            </Grid>
            <Grid item container xs={8}>
              <Grid item>
                <img src={`${EVENT_IMG}/welcome/welcome_img_7.png`} alt="" style={{ borderRadius: '50%', border: '5px solid #d4debc' }} />
              </Grid>
              <Grid item style={{ padding: theme.spacing(2, 0, 2, 2) }}>
                {/* <img src={`${EVENT_IMG}/welcome/chairman_sign.png`} alt="" /> */}
                <Typography style={{ fontWeight: 'bold', color: '#232323', marginTop: theme.spacing(1), paddingTop: 60 }}>
                  Kwang Sik Kook , M.D., Ph.D
                </Typography>
                <Typography style={{ color: '#555' }}>
                  {/* Chairman of Seoul Breast Meeting 2022 */}
                  {/* Chairman of General Assembly of Asian Forum for Fat and Stem Cells */}
                  President of Asian Forum for Fat and Stem Cells
                </Typography>
              </Grid>
            </Grid>
          </Grid>
        </Container>
        <Footer />
      </div>
    );
  }
}

export default withStyles(styles, { withTheme: true })(WelcomePage);
